<template>
    <form class="redeem" @submit.prevent="submit" :theme="theme">
        <div class="modal-title center">Redeem a Product Code</div>
        <div class="modal-description center">Please enter your seven character redemption code in order to access your textbook.</div>
        <input type="text" v-model="code" placeholder="• • • • • • •" />
        <button type="submit">Redeem Code</button>
    </form>
</template>

<script>
    export default {
        name: 'Redeem',
        data(){
            return {
                code: ''
            };
        },
        computed: {
            theme(){
                return this.$store.state.theme.active;
            }
        },
        methods: {
            submit(){
                this.$http.post('/licenses', {code: this.code})
                .then(response => {
                    return this.$store.dispatch('products/load')
                    .then(() => this.$store.dispatch('products/activate', {product_id: response.$data.product_id}))
                    .then(() => this.$emit('close'))
                    .then(() => this.$router.push({name: 'product.contents', params: {product: this.$store.getters.product.product_slug}}))
                    .then(() => window.location.reload());
                })
                .catch(error => this.$toasted.error('There was an error redeeming this product code.'))
            }
        }
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";

    .redeem
    {
        background: var(--modal-background-color);
        border-radius: 3px;
        padding: 20px;

        .modal-description
        {
            margin-bottom: 20px;
            line-height: 16px;
        }

        button
        {
            margin-top: 20px;
            width: 100%;
        }
    }
</style>
